<template>
  <div class="wrapper">
    <table>
      <caption colspan="2">〈漫画家〉 東村 アキコ</caption>
      <tbody>
        <tr>
          <th>1975年</th>
          <td>宮崎県串間市生まれ</td>
        </tr>
        <tr>
          <th>1994年</th>
          <td>県立宮崎西高校卒業</td>
        </tr>
        <tr>
          <th>同年</th>
          <td>金沢美術工芸大学 油画専攻入学。秋の学園祭「美大祭」でとり野菜みそと出会い、以降、虜に。</td>
        </tr>
        <tr>
          <th>1998年</th>
          <td>同大 卒業<br>卒業後、会社勤務の傍ら漫画創作活動を開始。<br>ぶ～けデラックス増刊号「フルーツこうもり」で漫画家デビュー。</td>
        </tr>
        <tr>
          <th>1999年</th>
          <td>ぶ～けデラックス増刊号「フルーツこうもり」で漫画家デビュー。</td>
        </tr>
        <tr>
          <th>2001年</th>
          <td>Cookie「きせかえユカちゃん」連載開始、少女漫画家にしてギャク漫画家の才能をも開花させる。</td>
        </tr>
        <tr>
          <th>2010年</th>
          <td>「海月姫」講談社漫画賞受賞</td>
        </tr>
        <tr>
          <th>2012年</th>
          <td>「主に泣いてます」ドラマ化（CX）</td>
        </tr>
        <tr>
          <th>2014年</th>
          <td>「海月姫」実写映画化</td>
        </tr>
        <tr>
          <th>2015年</th>
          <td>自伝漫画「かくかくしかじか」がマンガ大賞2015および文化庁メディア芸術祭漫画部門大賞を、<br>「東京タラレバ娘」がananマンガ大賞の大賞を受賞。</td>
        </tr>
        <tr>
          <th>2017年</th>
          <td>「東京タラレバ娘」ドラマ化（NTV）</td>
        </tr>
        <tr>
          <th>2013年〜</th>
          <td>京都精華大学・マンガ学部客員教授2014年より宮崎県「みやざき大使」</td>
        </tr>
        <tr>
          <th>2017年〜</th>
          <td>金沢美大・油画専攻非常勤講師</td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <th colspan="2">【その他の作品】</th>
        </tr>
        <tr>
          <td colspan="2">「ひまわりっ」 「ママはテンパリスト」 「メロポンだし！」 「雪花の虎」 「美食探偵 −明智五郎−」<br>
          「即席ビジンのつくりかた」他多数</td>
        </tr>
      </tfoot>
    </table>

    <a href="http://www.toriyasaimiso.jp/" class="btnBrandtop" target="_blank"><img src="../assets/images/btn_footer.svg" alt="とり野菜みそオフィシャルサイトへ"></a>
  </div>
</template>

<script>
  export default {
  }
</script>

<style lang="scss" scoped>
  @import "../assets/scss/common";

  .wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 3vw;
  }

  table {
    table-layout: fixed;
    border-collapse: separate;
  }

  caption {
    font-size: 1.6rem;
    text-align: left;

    @include media(sm) {
      font-size: 2.0rem;
    }

    @include media(md) {
      font-size: 2.6rem;
    }
  }

  tbody, tfoot {
    &::before {
      content: "";
      display: block;
      height: 1.5rem;
    }
  }

  tbody {
    padding: 1.5rem 0;

    th {
      padding-right: .85em;
      border-right: 1px solid #000;
      text-align: right;
    }

    td {
      padding-left: .85em;
    }
  }

  tfoot {
    th {
      text-align: left;
    }
  }

  th, td {
    font-size: 1.1rem;
    line-height: 1.5;

    @include media( sm ) {
      font-size: 1.3rem;
    }

    @include media( md ) {
      font-size: 1.5rem;
    }
  }

  th {
    min-width: 6em;
  }

  td {
    text-align: left;
  }
</style>



// WEBPACK FOOTER //
// src/components/Profile.vue?f3c728f0